module.exports = __webpack_public_path__ + "static/media/versace-eros-big.9d4968f2.png";